/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import {SchemaSpecification} from './schema.specification';
import {TSO}                 from '@/models/scenario/t.s.o';
import {Period}              from '@/util/period';

export class SlowOrdersSchema extends SchemaSpecification {

  constructor() {

    super();

    this.jsonSpec = `{
"slow_orders": {
  "schema": {
    "fields": [
      {
        "name": "tso_id",
        "title": "client generated id for this tso, must be unique within model",
        "type": "integer",
        "col": 1,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "name",
        "title": "human readable tso name",
        "type": "string",
        "col": 2,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "description",
        "title": "human readable tso name",
        "type": "string",
        "col": 3,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "start",
        "title": "Time, P00DT12H00M00s, sim day/time when to start TSO",
        "type": "string",
        "col": 4,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "duration",
        "title": "Time, P00DT12H00M00s, duration of TSO.",
        "type": "string",
        "col": 5,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "tonnage_release",
        "title": "Number of short tons before TSO is lifted.  Set to 0 if N/A",
        "type": "float",
        "col": 6,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "east_mp",
        "title": "East end of TSO (low MP). ",
        "type": "float",
        "col": 7,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "west_mp",
        "title": "West end of TSO (high MP). ",
        "type": "float",
        "col": 8,
        "constraints": {
          "required": true
        }
      }
    ]
  },
  "dataType": "table",
  "data": [
  ]
}
}`;

    super.cache();
  }

  /** convert the given object to data table row(s), only properties that match field names will be created. */
  public toRow(object: any): any[] {

    const tso: TSO = object as TSO;

    /* each TSO object generates one slow_order row */

    const proxy: any = {
      tso_id:          tso._id,
      name:            tso._name,
      description:     tso._description,
      start:           Period.toString(tso._start),
      duration:        Period.toString(tso._duration),
      tonnage_release: tso._tonnage,
      east_mp:         tso._eastMile,
      west_mp:         tso._westMile,
    };

    /* now convert that */

    return super.toRow(proxy);
  }

  /** helper to insert TSO (slow_order sub-section) into a scenario slow_orders section, returns the full object, ready to be saved. */
  render(items: TSO[]): any {

    /* create the data table */

    const d = this.dataTable(items);

    /* insert */

    const w: any = this.findObject('slow_orders', this.schemaObj);

    if (w === null) {

      this.lastError = `(render) problems finding slow_orders section: ${this.lastError}`;

      return null;
    }

    w['data'] = d;

    /* pass back the full rendered version, this version can be given to JSON.stringify() to save to file. */

    return this.schemaObj;
  }

}
